import { useaxios } from "../../../utils/useaxios";
export default (company_name, company_address, company_phone, company_base_loan, user_id) => recaller => setrecaller => initDispatch => clear => {
    // export default (company_name, company_address, company_phone, company_base_loan, company_date, user_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('company/create.php', { company_name, company_address, company_phone, company_base_loan, user_id }).then((res) => {
        // useaxios('company/create.php', { company_name, company_address, company_phone, company_base_loan, company_date, user_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}